import { SubNav } from '@/components/ui/page';

/** Tabs between the knowledge base's subpages (REM-2, REM-3). */
const KnowledgeNav = () => (
  <SubNav
    label="Knowledge base"
    items={[
      { to: '/knowledge', label: 'Articles', end: true },
      { to: '/knowledge/answers', label: 'Bot answers' },
    ]}
  />
);

/** What the bot does with the articles, under the page's top bar (it scrolls away; the tabs stay). */
export const KnowledgeNote = () => (
  <p className="mb-6 text-sm text-fg-muted">
    When a client or a team member asks something on Telegram, the bot answers at once with an article&rsquo;s short answer, saying a person will confirm it, with 👍 and
    👎 under it (Q19). A team member&rsquo;s 👎 removes it from the chat; improve the article it came from, under Bot answers. By email the bot only
    drafts, and a person confirms or corrects it there. Matching is by keywords until the AI provider is chosen (Q10).
  </p>
);

export default KnowledgeNav;
